import { DomainLv1, DomainLv1FormData } from "../types"
import { ID, PaginationResult } from "@/types/common"
import { createCrudApi } from "@/utils/apiFactory"
import http from "@/utils/request"

export type AssistTypeOption = {
  id: ID
  code: string
  label: string
  enabled: boolean
}

const baseApi = createCrudApi<DomainLv1, DomainLv1FormData, DomainLv1FormData>(
  "/domain-lv1s"
)

// 一级领域API
const domainLv1Api = {
  // 查询所有
  async getList(): Promise<PaginationResult<DomainLv1>> {
    return baseApi.list()
  },

  // ID查询
  async getById(id: ID): Promise<DomainLv1 | null> {
    return baseApi.getById(id)
  },

  // 创建
  async create(data: DomainLv1FormData): Promise<void> {
    await baseApi.create(data)
  },

  // 更新
  async update(id: ID, data: DomainLv1FormData): Promise<void> {
    await baseApi.update(id, data)
  },

  // 删除（统一使用数组参数，支持单个和批量）
  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },

  // 获取辅助类型字典项选项（assist_type分类）
  async getAssistTypeOptions(): Promise<AssistTypeOption[]> {
    const res = await http.get<any[]>("/domain-lv1s/assist-type-options")
    const data = res.data || []
    return data.map((item: any) => ({
      id: item.id,
      code: item.code,
      label: item.label,
      enabled: item.enabled,
    }))
  },

  // 获取一级领域当前绑定的辅助类型字典项ID
  async getAssistTypeBindings(domainLv1Id: ID): Promise<ID[]> {
    const res = await http.get<{
      assistTypeItemIds: ID[]
    }>(`/domain-lv1s/${domainLv1Id}/assist-type-bindings`)
    return res.data?.assistTypeItemIds || []
  },

  // 获取一级领域当前绑定的辅助类型字典项
  async getBoundAssistTypes(domainLv1Id: ID): Promise<AssistTypeOption[]> {
    const res = await http.get<{
      assistTypes: AssistTypeOption[]
    }>(`/domain-lv1s/${domainLv1Id}/assist-type-bindings`)
    return res.data?.assistTypes || []
  },

  // 覆盖更新一级领域辅助类型绑定
  async updateAssistTypeBindings(
    domainLv1Id: ID,
    assistTypeItemIds: ID[]
  ): Promise<void> {
    await http.put(`/domain-lv1s/${domainLv1Id}/assist-type-bindings`, {
      assistTypeItemIds,
    })
  },
}

export default domainLv1Api
